import React from 'react';
import { observer } from 'mobx-react-lite';
import { roundInfoStore } from '@pascal/pascal-core/shared/core/store';

import { roundTimeStore } from '../../../store';
import { chartStore } from '../../../store/chartStore';

export const Timer = observer(() => {
  const { time, passedSeconds } = roundTimeStore;
  const { duration } = roundInfoStore;
  const { isAnimationState } = chartStore;

  const bigCircleDuration = duration * 0.425;

  const middleCircleDuration = duration * 0.571;

  const smallCircleDuration = duration * 0.857;

  const bigCircleDelay = -1 - passedSeconds;

  const middleCircleDelay = 0 - passedSeconds;

  const smallCircleDelay = 1 - passedSeconds;

  return time > 0 && !isAnimationState ? (
    <div className='crash-countdown show startCountDownAnim'>
      <div className='crash-countdown-circles'>
        <div className='crash-countdown-circle'>
          <svg viewBox='0 0 100 100'>
            <defs>
              <linearGradient x1='0%' y1='0%' x2='100%' y2='0%' id='wc-gradient-0'>
                <stop offset='0%' stopColor='#fd4a95' />
                <stop offset='100%' stopColor='#ff9954' />
              </linearGradient>
            </defs>
            <path d='M 50,50 m 0,-47a 47,47 0 1 1 0,94a 47,47 0 1 1 0,-94' />
            <path
              d='M 50,50 m 0,-47a 47,47 0 1 1 0,94a 47,47 0 1 1 0,-94'
              style={{
                animationDuration: `${bigCircleDuration}s`,
                animationDelay: `${bigCircleDelay}s`,
              }}
              className='countdown-circle-path countdown-circle-path-1'
            />
          </svg>
          <div
            className='wc-arrow'
            style={{
              animationDuration: `${bigCircleDuration}s`,
              animationDelay: `${bigCircleDelay}s`,
            }}
          >
            <div
              className='icon crash-icon-arrow-drop'
              style={{
                animationDuration: `${bigCircleDuration}s`,
                animationDelay: `${bigCircleDelay}s`,
              }}
            />
          </div>
        </div>
        <div className='crash-countdown-circle'>
          <svg viewBox='0 0 100 100'>
            <defs>
              <linearGradient x1='0%' y1='0%' x2='100%' y2='0%' id='wc-gradient-1'>
                <stop className='middle-circle-stop-1' offset='0%' />
                <stop className='middle-circle-stop-2' offset='100%' />
              </linearGradient>
            </defs>
            <path d='M 50,50 m 0,-47a 47,47 0 1 1 0,94a 47,47 0 1 1 0,-94' />
            <path
              d='M 50,50 m 0,-47a 47,47 0 1 1 0,94a 47,47 0 1 1 0,-94'
              style={{
                animationDuration: `${middleCircleDuration}s`,
                animationDelay: `${middleCircleDelay}s`,
              }}
              className='countdown-circle-path countdown-circle-path-2'
            />
          </svg>
          <div
            className='wc-arrow'
            style={{
              animationDuration: `${middleCircleDuration}s`,
              animationDelay: `${middleCircleDelay}s`,
            }}
          >
            <div
              className='icon crash-icon-arrow-drop'
              style={{
                animationDuration: `${middleCircleDuration}s`,
                animationDelay: `${middleCircleDelay}s`,
              }}
            />
          </div>
        </div>
        <div className='crash-countdown-circle'>
          <svg viewBox='0 0 100 100'>
            <defs>
              <linearGradient x1='0%' y1='0%' x2='100%' y2='0%' id='wc-gradient-2'>
                <stop offset='0%' stopColor='#8356ee' />
                <stop offset='100%' stopColor='#38a0ee' />
              </linearGradient>
            </defs>
            <path d='M 50,50 m 0,-47a 47,47 0 1 1 0,94a 47,47 0 1 1 0,-94' />
            <path
              d='M 50,50 m 0,-47a 47,47 0 1 1 0,94a 47,47 0 1 1 0,-94'
              style={{
                animationDuration: `${smallCircleDuration}s`,
                animationDelay: `${smallCircleDelay}s`,
              }}
              className='countdown-circle-path countdown-circle-path-3'
            />
          </svg>
          <div
            className='wc-arrow'
            style={{
              animationDuration: `${smallCircleDuration}s`,
              animationDelay: `${smallCircleDelay}s`,
            }}
          >
            <div
              className='icon crash-icon-arrow-drop'
              style={{
                animationDuration: `${smallCircleDuration}s`,
                animationDelay: `${smallCircleDelay}s`,
              }}
            />
          </div>
        </div>
        <div className='crash-countdown-timer'>
          <span>{time}</span>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
});
